// @flow

import React from 'react';

export const DEFAULT_GEOMETRY_FORMAT = 'notam';

export const GEOMETRY_FORMATS = {
  decimalDegrees: {
    name: 'Tizedes fok',
    sample: '47.425N 017.654E',

    polygonalDescription: (
      <p>
        A sokszög koordinátapárjai térközzel elválasztva,{' '}
        <code>47.425663N 017.654829E</code> formátumban adhatóak meg.
      </p>
    ),

    circularDescription: (
      <p>
        Kör <code>47.425663N 017.654829E R=1.2KM</code> formátumban adható meg,
        ahol <code>R</code> a kör sugara méterben (<code>M</code>) vagy
        kilométerben (<code>KM</code>) megadva.
      </p>
    ),

    miscDescription: (
      <p>
        A földrajzi hosszúságokat mindkét esetben a <code>0</code> vezérszám
        előzheti meg.
      </p>
    ),
  },

  dms: {
    name: 'Fok, perc, másodperc',
    sample: '47° 29′ 20.8788″ N 18° 59′ 57.4836″ E',

    polygonalDescription: (
      <p>
        A sokszög koordinátapárjai térközzel elválasztva,{' '}
        <code>47° 29′ 20.8788″ N 18° 59′ 57.4836″ E</code> formátumban adhatóak
        meg.
      </p>
    ),

    circularDescription: (
      <p>
        Kör <code>47° 29′ 20.8788″ N 18° 59′ 57.4836″ E R=1.2KM</code>{' '}
        formátumban adható meg, ahol <code>R</code> a kör sugara méterben (<code
        >
          M
        </code>) vagy kilométerben (<code>KM</code>) megadva.
      </p>
    ),

    miscDescription: (
      <p>
        A fokpercek a <code>&apos;</code> (aposztróf) <code>′</code> (láb) és
        <code>’</code> (harmadlagos idézőjel) karakterekkel, a fokmásodpercek a{' '}
        <code>&quot;</code> (írógép-idézőjel), <code>″</code> (hüvelyk),{' '}
        <code>”</code> (záró idézőjel) és <code>&apos;&apos;</code> (dupla
        aposztróf) karakterekkel jelölhetőek.
      </p>
    ),
  },

  notam: {
    name: 'NOTAM',
    sample: '472906N 0190307E',

    polygonalDescription: (
      <p>
        A sokszög koordinátapárjai térközzel elválasztva,{' '}
        <code>472906N 0190307E</code> (fok, perc, másodperc) formátumban
        adhatóak meg.
      </p>
    ),

    circularDescription: (
      <p>
        Kör <code>472906N 0190307E R=1.2KM</code> formátumban adható meg, ahol{' '}
        <code>R</code> a kör sugara méterben (<code>M</code>) vagy kilométerben
        (<code>KM</code>) megadva.
      </p>
    ),

    miscDescription: (
      <p>
        A földrajzi hosszúságokat mindkét esetben a <code>0</code> vezérszám
        előzheti meg.
      </p>
    ),
  },

  eov: {
    name: 'Egységes Országos Vetület',
    sample: '652164.287 238405.813',

    polygonalDescription: (
      <p>
        A sokszög koordinátapárjai térközzel elválasztva,{' '}
        <code>652164.287 238405.813</code> formátumban adhatóak meg.
      </p>
    ),

    circularDescription: (
      <p>
        Kör <code>652164.287 238405.813 R=1.2KM</code> formátumban adható meg,
        ahol <code>R</code> a kör sugara méterben (<code>M</code>) vagy
        kilométerben (<code>KM</code>) megadva.
      </p>
    ),

    miscDescription: (
      <p>
        Az EOV koordinátapárok <code>X</code> és <code>Y</code> tagjának
        sorrendje (a geodéziai és a térinformatikai konvenció eltérése miatt)
        tetszőlegesen megválasztható, amíg azok megfelelnek az ország területén
        érvényes{' '}
        <code style={{ whiteSpace: 'nowrap' }}>X &lt; 400.000 m &lt; Y</code>{' '}
        feltételnek.
      </p>
    ),
  },
};

export type GeometryFormat = $Keys<typeof GEOMETRY_FORMATS>;



// WEBPACK FOOTER //
// ./utils/geometryFormats.js